<template>
  <div class="container">
    <my-nav-ui :idx="0"></my-nav-ui>
    <div class="bottom">
      <div class="left">
        <div
          class="content row1"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label>电梯梯龄分布</label>
          <div
            id="charts9"
            style="height: calc(100% - 30px); width: 100%"
          ></div>
        </div>
        <div
          class="content row2"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label>电梯品牌分布</label>
          <div
            id="charts10"
            style="height: calc(100% - 30px); width: 100%"
          ></div>
        </div>
        <div
          class="content row3"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label>电梯场所分布</label>
          <div
            id="charts11"
            style="height: calc(100% - 30px); width: 100%"
          ></div>
        </div>
      </div>
      <div class="center">
        <div class="row1">
          <my-echarts-map-ui :mapId="11"></my-echarts-map-ui>
        </div>
        <div
          class="content row2"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <div
            v-if="regionType == 0"
            class="img"
            style="background-image: url('../../static/dtsl-bg-g.png')"
          >
            <label>{{ prefixIntrger(fixingTotal, 6) }}</label>
          </div>
          <div
            v-else-if="regionType == 2"
            
            class="img"
            style="background-image: url('../../static/dtsl-bg.png')"
          >
            <label>{{ prefixIntrger(fixingTotal, 6) }}</label>
          </div>
          <div
            v-else-if="regionType == 3 && cityName.indexOf('区') != -1"
            
            class="img"
            style="background-image: url('../../static/dtsl-bg-q.png')"
          >
            <label>{{ prefixIntrger(fixingTotal, 6) }}</label>
          </div>
          <div
          v-else-if="regionType == 3 && cityName.indexOf('市') != -1"
            
            class="img"
            style="background-image: url('../../static/dtsl-bg.png')"
          >
            <label>{{ prefixIntrger(fixingTotal, 6) }}</label>
          </div>
          <div
          v-else-if="regionType == 3 && cityName.indexOf('县') != -1"
            
            class="img"
            style="background-image: url('../../static/dtsl-bg-x.png')"
          >
            <label>{{ prefixIntrger(fixingTotal, 6) }}</label>
          </div>
          <div
            v-else
            
            class="img"
            style="background-image: url('../../static/dtsl-bg-q.png')"
          >
            <label>{{ prefixIntrger(fixingTotal, 6) }}</label>
          </div>
          <div class="list">
            <div class="list1" v-if="managerankByfixingList">
              <label @click="test">使用单位电梯排名前十</label>
              <div
                class="item"
                v-for="item in managerankByfixingList"
                :key="item.name"
              >
                <span>{{ item.groupName }}</span>
                <span>{{ item.totalCount }}台</span>
              </div>
            </div>
            <div class="list2" v-if="maintainrankByfixingList">
              <label>维保单位电梯排名前十</label>
              <div
                class="item"
                v-for="item in maintainrankByfixingList"
                :key="item.name"
              >
                <span>{{ item.groupName }}</span>
                <span>{{ item.totalCount }}台</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="row1">
          <div
            class="content"
            style="height: 50%; width: 100%"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          >
            <label>电梯故障类型分布</label>
            <div
              id="charts13"
              style="height: calc(100% - 30px); width: 100%"
            ></div>
          </div>
          <div
            class="content"
            style="height: calc(50% - 10px); width: 100%; margin-top: 10px"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="#121D49"
          >
            <label>电梯故障原因分布</label>
            <div
              id="charts14"
              style="height: calc(100% - 30px); width: 100%"
            ></div>
          </div>
        </div>
        <div
          class="content row2"
          v-loading="loading"
          element-loading-spinner="el-icon-loading"
          element-loading-background="#121D49"
        >
          <label>近六月故障趋势</label>
          <div
            id="charts15"
            style="height: calc(100% - 30px); width: 100%"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from '@/api/global_variable'
import chartsView4 from '@/api/charts_view4'
import axios from 'axios'
let router = null
let ajax = null
export default {
  name: 'Home',
  data() {
    return {
      loading: true,
      managerankByfixingList: [], //使用单位排名前10
      maintainrankByfixingList: [], //维保单位排名前10
      fixingTotal: 0,
      requestNum: 0,
      // totalSize: GLOBAL.eTotal,
      Timer: null,
      orgId: '',
      regionType: 0,
      cityName: ''
    }
  },
  mounted() {
    if (!GLOBAL.isLogin()) {
      this.$router.push({ path: '/login' })
    } else {
      GLOBAL.curPage = 0
      this.loading = false
      chartsView4.setEcharts(this.$echarts)
      this.drawCharts()
      if (this.Timer === null) {
        var that = this
        this.Timer = setInterval(function () {
          that.drawCharts()
        }, 30000)
      }
    }

    // GLOBAL.curPage = 0
    // ajax = this.$ajax
    // router = this.$router
    // if (this.Timer === null) {
    //   var that = this
    //   this.Timer = setInterval(function() {
    //     that.drawCharts()
    //   }, 30000)
    // }
  },
  beforeDestroy() {
    clearInterval(this.Timer)
    this.Timer = null
  },
  created() {
    this.getData()
    // const totalData = GLOBAL.areaData //静态数据
    // const cityName = sessionStorage.getItem('cityName')
    // for (var j = 0; j < totalData.length; j++) {
    //   if (totalData[j].city === cityName) {
    //     this.totalSize = totalData[j].total
    //     // GLOBAL.eTotal = totalData[j].total
    //   }
    // }
    //0:省 1:市 2:区县
    this.cityName = sessionStorage.getItem('cityName')
    this.regionType = sessionStorage.getItem('regionType')
    console.log(this.regionType)
  },
  methods: {
    test: function () {
      if (this.ViewData) {
        // this.ViewData.TotalSituation.ElevartorCountTop10ByUsingUnitStatistics[1].Name = 'AAA'
      }
    },
    getData: function () {
      ++this.requestNum
      this.loading = false
      this.drawCharts()
    },
    drawCharts: function () {
      this.orgId = this.$route.params.orgId
      if (GLOBAL.curPage === 0) {
        this.drawCharts1()
        this.drawCharts2()
        this.drawCharts3()
        // this.drawCharts4()
        this.drawCharts5()
        this.drawCharts6()
        this.drawCharts7()
        this.drawCharts8()
        this.drawCharts9()
        this.drawCharts10()
      }
    },
    // 电梯梯龄分布
    drawCharts1: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/byusedate',
      }).then((res) => {
        var v = []
        var arr = res.data.result
        for (var k = arr.length - 1; k > 0; k--) {
          for (var l = 0; l < k; l++) {
            if (arr[l].totalCount < arr[l + 1].totalCount) {
              ;[arr[l], arr[l + 1]] = [arr[l + 1], arr[l]]
            }
          }
        }
        // 数据转换
        if (res.data.result) {
          for (var i = 0; i < res.data.result.length; i++) {
            v.push({
              name: res.data.result[i].groupName, //名称
              value: res.data.result[i].totalCount, //值
            })
          }
        }
        // end
        //渲染图形
        var option = chartsView4.getOption1(v)
        var div_ = document.getElementById('charts9')
        div_.removeAttribute('_echarts_instance_')
        var chart1 = this.$echarts.init(div_)
        chart1.setOption(option)
      })
    },
    // 电梯品牌分布
    drawCharts2: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/bybrand',
      }).then((res) => {
        var v = []
        var arr = res.data.result
        for (var k = arr.length - 1; k > 0; k--) {
          for (var l = 0; l < k; l++) {
            if (arr[l].totalCount < arr[l + 1].totalCount) {
              ;[arr[l], arr[l + 1]] = [arr[l + 1], arr[l]]
            }
          }
        }
        if (arr.length > 5) {
          for (var i = 0; i < 5; i++) {
            v.push({
              name: arr[i].groupName,
              value: arr[i].totalCount,
            })
          }
          let otherCount = 0
          for (var j = 5; j < arr.length; j++) {
            otherCount += arr[j].totalCount
          }
          v.push({
            name: '其他',
            value: otherCount,
          })
        } else {
          for (var i = 0; i < res.data.result.length; i++) {
            v.push({
              name: res.data.result[i].groupName,
              value: res.data.result[i].totalCount,
            })
          }
        }
        var option = chartsView4.getOption2(v)
        var div_ = document.getElementById('charts10')
        div_.removeAttribute('_echarts_instance_')
        var chart2 = this.$echarts.init(div_)
        chart2.setOption(option)
      })
    },
    // 电梯场所分布
    drawCharts3: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/byuseplace',
      }).then((res) => {
        var x = []
        var s1 = []
        var arr = res.data.result
        for (var k = arr.length - 1; k > 0; k--) {
          for (var l = 0; l < k; l++) {
            if (arr[l].totalCount < arr[l + 1].totalCount) {
              ;[arr[l], arr[l + 1]] = [arr[l + 1], arr[l]]
            }
          }
        }
        for (var i = 0; i < arr.length; i++) {
          x.push(res.data.result[i].groupName)
          s1.push(res.data.result[i].qty)
        }

        var option = chartsView4.getOption3(x, s1)
        var div_ = document.getElementById('charts11')
        div_.removeAttribute('_echarts_instance_')
        var chart3 = this.$echarts.init(div_)
        chart3.setOption(option)
      })
    },
    // 电梯分布地图
    // async drawCharts4() {
    //   const res = await this.axios({
    //     headers: {
    //       orgId: sessionStorage.getItem('orgId')
    //     },
    //     methods: 'get',
    //     url: 'Visual/fixing/byarea'
    //   })
    //   console.log(res)
    //   var s = []
    //   var geo = chartsView4.mapCenterData()
    //   //
    //   for (var j = 0; j < res.data.result.length; j++) {
    //     var item = res.data.result.length;
    //     s.push({
    //       level: 1,
    //       name: item.groupName,
    //       value: item.totalCount,
    //       total: item.totalCount,
    //       aa: 0,
    //       ff: 0,
    //       cc: 0,
    //       status: 20,
    //       ItemRegion: '',
    //       lng: 0,
    //       lat: 0,
    //       bb: 'bbb',
    //       sa: 'sa'
    //     })
    //   }
    //   this.$http('http://visual.api.tywliot.com:8080/static/geo/431000.json')
    //     .then(res => {
    //       this.$echarts.registerMap('jiangxi', res.data)
    //       var chart4 = this.$echarts.init(document.getElementById('charts12'))
    //       var option = chartsView4.chartsMap(s)
    //       chart4.setOption(option)
    //       // 防止重复触发点击事件
    //       if (chart4._$handlers.click) {
    //         chart4._$handlers.click.length = 0
    //       }
    //       // 添加事件 会重复注册
    //       chart4.on('click', function(params) {
    //         if (params.data.lng) {
    //           router.push({
    //             path: '/map',
    //             query: {
    //               name: params.data.name,
    //               lng: params.data.lng,
    //               lat: params.data.lat
    //             }
    //           })
    //         }
    //       })
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },
    // 电梯故障类型分布
    drawCharts5: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/bytype',
      }).then((res) => {
        var v = []
        if (res.data.result) {
          var arr = res.data.result
          for (var k = arr.length - 1; k > 0; k--) {
            for (var l = 0; l < k; l++) {
              if (arr[l].happenCount < arr[l + 1].happenCount) {
                ;[arr[l], arr[l + 1]] = [arr[l + 1], arr[l]]
              }
            }
          }
          if (arr.length > 5) {
            for (var i = 0; i < 5; i++) {
              v.push({
                name: arr[i].faultName,
                value: arr[i].happenCount,
              })
            }
            let otherCount = 0
            for (var j = 5; j < arr.length; j++) {
              otherCount += arr[j].happenCount
            }
            v.push({
              name: '其他',
              value: otherCount,
            })
          } else {
            for (var i = 0; i < res.data.result.length; i++) {
              v.push({
                name: res.data.result[i].faultName,
                value: res.data.result[i].happenCount,
              })
            }
          }
        }
        var option = chartsView4.getOption5(v)
        var div_ = document.getElementById('charts13')
        div_.removeAttribute('_echarts_instance_')
        var chart5 = this.$echarts.init(div_)
        chart5.setOption(option)
      })
    },
    // 电梯故障原因分布
    drawCharts6: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/byreason',
      }).then((res) => {
        var v = []
        if (res.data.result) {
          for (var i = 0; i < res.data.result.length; i++) {
            v.push({
              name: res.data.result[i].faultName == 1 ? '人工报警' : '故障报警',
              value: res.data.result[i].happenCount,
            })
          }
        }
        var option = chartsView4.getOption6(v)
        var div_ = document.getElementById('charts14')
        div_.removeAttribute('_echarts_instance_')
        var chart6 = this.$echarts.init(div_)
        chart6.setOption(option)
      })
    },
    // 近六月故障趋势
    drawCharts7: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fault/lateshalfyear/bymonth',
      }).then((res) => {
        var s1 = []
        var s2 = []
        if (res.data.result) {
          for (var i = 0; i < res.data.result.length; i++) {
            s1.push(res.data.result[i].perMonth)
            s2.push(res.data.result[i].totalFaultCount)
          }
        }
        var option = chartsView4.getOption7(s1, s2)
        var div_ = document.getElementById('charts15')
        div_.removeAttribute('_echarts_instance_')
        var chart7 = this.$echarts.init(div_)
        chart7.setOption(option)
      })
    },
    // 使用单位排名前十
    drawCharts8: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/unit/managerank/byfixing',
      }).then((res) => {
        this.managerankByfixingList = res.data.result
        this.managerankByfixingList.sort(function (a, b) {
          var totalNumA = a.totalNum
          var totalNumB = b.totalNum
          if (totalNumA < totalNumB) {
            return -1
          }
          if (totalNumA > totalNumB) {
            return 1
          }
          return 0
        })
      })
    },
    // 维保单位排名前十
    drawCharts9: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/unit/maintainrank/byfixing',
      }).then((res) => {
        this.maintainrankByfixingList = res.data.result
        this.maintainrankByfixingList.sort(function (a, b) {
          var totalNumA = a.totalNum
          var totalNumB = b.totalNum
          if (totalNumA < totalNumB) {
            return -1
          }
          if (totalNumA > totalNumB) {
            return 1
          }
          return 0
        })
      })
    },
    // 全市电梯总数
    drawCharts10: function () {
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId'),
        },
        methods: 'get',
        url: process.env.API_ROOT + '/Visual/fixing/count',
      }).then((res) => {
        this.fixingTotal = res.data.result
        // console.log(this.fixingTotal)
      })
    },
    prefixIntrger(num, length) {
      //num = this.fixingTotal
      return (Array(length).join('0') + num).slice(-length)
    },
  },
}
</script>
<style lang="css" rel="stylesheet/scss" scoped>
.container {
  width: 100%;
  height: calc(100% - 40px);
  background: #0b133f;
}
.bottom {
  height: calc(100% - 110px);
  width: 98%;
  display: inline-flex;
}
.bottom .left {
  width: 25%;
  height: 100%;
  padding-top: 10px;
}
.bottom .center {
  width: 50%;
  height: 100%;
  padding-top: 10px;
}
.bottom .right {
  width: 25%;
  height: 100%;
  padding-top: 10px;
}
.bottom .content {
  background: #121d49 !important;
  border-radius: 6px;
}
.bottom .content label {
  display: block;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
  font-weight: bold;
  text-align: left;
  padding-left: 10px;
  letter-spacing: 2px;
  width: 100%;
}
.bottom .left .row1 {
  height: calc(33% - 10px);
  width: 100%;
}
.bottom .left .row2 {
  margin-top: 10px;
  height: calc(33% - 10px);
  width: 100%;
}
.bottom .left .row3 {
  margin-top: 10px;
  height: calc(34% - 10px);
  width: 100%;
}
.bottom .center .row1 {
  width: calc(100% - 20px);
  height: calc(100% - 360px);
  margin: 0px 10px 0px 10px;
}
.bottom .center .row1 .num div {
  width: 25%;
  height: 100%;
}
.bottom .center .row1 .num div span:nth-child(1) {
  display: flex;
  width: 100%;
  height: 35%;
  color: #fff;
  font-weight: bold;
  letter-spacing: 1px;
  justify-content: center;
  align-items: flex-end;
}
.bottom .center .row1 .num div span:nth-child(2) {
  display: block;
  width: 100%;
  height: 65%;
  letter-spacing: 2px;
  font-size: 32px;
}
.bottom .center .row2 {
  height: 340px;
  margin: 10px 10px 10px 10px;
  display: flex;
  flex-direction: column;
}
.bottom .center .row2 .img {
  width: 360px;
  height: 72px;
  background: url('../../static/dtsl-bg.png') no-repeat;
  background-size: 360px 72px;
  margin-left: calc(50% - 180px);
  margin-top: -36px;
  z-index: 999;
}
.bottom .center .row2 .img label {
  display: block;
  margin-left: 76px;
  line-height: 72px;
  font-size: 38px;
  color: #fff;
  letter-spacing: 20px;
}
.bottom .center .row2 .list {
  width: 100%;
  height: calc(100% - 36px);
  display: inline-flex;
}
.bottom .center .row2 .list .item {
  height: 26px;
  width: 90%;
  text-align: left;
  color: #6c89aa;
  font-size: 14px;
  display: flex;
  line-height: 30px;
}
.bottom .center .row2 .list .list2 .item {
  margin-left: 10%;
}
.bottom .center .row2 .list .item span:nth-child(1) {
  display: block;
  width: calc(100% - 80px);
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
}
.bottom .center .row2 .list .item span:nth-child(2) {
  display: block;
  width: 80px;
  text-align: right;
  padding-left: 10px;
}
.bottom .center .row2 .list .list1 {
  width: 46%;
  margin-left: 3%;
  height: 100%;
}
.bottom .center .row2 .list .list1 label {
  text-align: left !important;
  padding-left: 0px !important;
}
.bottom .center .row2 .list .list2 {
  width: 46%;
  height: 100%;
}
.bottom .center .row2 .list .list2 label {
  text-align: right !important;
}
.bottom .center .row2 .row2l2 {
  height: 100%;
  width: calc(62% - 5px);
  margin-left: 5px;
}
.bottom .center .row3 {
  width: calc(100% - 20px);
  height: 33%;
  margin: 0px 10px 0px 10px;
}
.bottom .right .row1 {
  height: calc(66% - 10px);
  width: 100%;
}
.bottom .right .row2 {
  margin-top: 10px;
  height: calc(34% - 10px);
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue